(function () {
  'use strict';
  var core = window.BFFJourneyCore;
  if (!core) return;
  var key = 'bff-shopping-plan-v1';
  function read() {
    try {
      var plan = JSON.parse(sessionStorage.getItem(key));
      if (!plan || !Number.isFinite(plan.savedAt) || Date.now() - plan.savedAt < 0 || Date.now() - plan.savedAt > 7200000) return null;
      var mode = plan.mode === 'pickup' ? 'pickup' : 'delivery';
      var date = /^\d{4}-\d{2}-\d{2}$/.test(plan.date || '') && plan.date >= core.earliest(mode) && !core.sunday(plan.date) ? plan.date : '';
      return { mode: mode, zip: mode === 'delivery' ? core.zip(plan.zip || '') : '', date: date, occasion: typeof plan.occasion === 'string' ? plan.occasion : '', savedAt: plan.savedAt };
    } catch (error) { return null; }
  }
  function write(plan) {
    try { sessionStorage.setItem(key, JSON.stringify(plan)); } catch (error) {}
  }
  function syncFinder(form, restore) {
    var mode = form.querySelector('[data-bff-find-mode]');
    var zip = form.querySelector('[data-bff-find-zip]');
    var date = form.querySelector('[data-bff-find-date]');
    var plan = restore && read();
    if (plan) {
      mode.value = plan.mode;
      zip.value = plan.zip;
      date.value = plan.date;
      var occasion = form.querySelector('[data-bff-find-occasion]');
      if (Array.from(occasion.options).some(function (option) { return option.value === plan.occasion; })) occasion.value = plan.occasion;
    }
    zip.disabled = mode.value === 'pickup';
    form.querySelector('[data-bff-find-zip-wrap]').hidden = zip.disabled;
    date.min = core.earliest(mode.value);
    if (date.value && (date.value < date.min || core.sunday(date.value))) date.value = '';
    date.setCustomValidity('');
  }
  function context(scope) {
    var plan = read();
    (scope || document).querySelectorAll('[data-bff-shopping-context]').forEach(function (node) {
      if (!plan || (!plan.zip && !plan.date && plan.mode !== 'pickup')) { node.hidden = true; return; }
      var parts = [plan.mode === 'pickup' ? node.dataset.pickup : node.dataset.delivery];
      if (plan.zip && plan.mode === 'delivery') parts.push(node.dataset.zip + ' ' + plan.zip);
      if (plan.date) parts.push(new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(plan.date + 'T12:00:00Z')));
      node.querySelector('[data-bff-shopping-summary]').textContent = parts.join(' · ');
      node.hidden = false;
    });
  }
  function product(scope) {
    var plan = read();
    if (!plan) return;
    (scope || document).querySelectorAll('[data-bff-delivery-fields][data-bff-context="product"]').forEach(function (area) {
      if (area.dataset.bffPlanApplied) return;
      area.dataset.bffPlanApplied = 'true';
      var button = area.querySelector('[data-bff-mode-button="' + plan.mode + '"]');
      if (button && button.getAttribute('aria-pressed') !== 'true') button.click();
      var zip = area.querySelector('[data-bff-journey-zip]');
      if (zip && plan.mode === 'delivery' && plan.zip) {
        if (!zip.value) zip.value = plan.zip;
        if (zip.value === plan.zip) zip.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (plan.mode === 'pickup' && window.BFFCheckoutPrefill) window.BFFCheckoutPrefill.remember('');
      var date = area.querySelector('[data-bff-date]');
      if (date && !date.value && plan.date) { date.value = plan.date; date.dispatchEvent(new Event('change', { bubbles: true })); }
      if (window.BFFJourneyCalendar) window.BFFJourneyCalendar(area);
    });
  }
  function ready(scope) {
    (scope || document).querySelectorAll('[data-bff-gift-finder]').forEach(function (form) { syncFinder(form, true); });
    product(scope);
    context(scope);
  }
  document.addEventListener('change', function (event) {
    var form = event.target.closest('[data-bff-gift-finder]');
    if (form && event.target.matches('[data-bff-find-mode]')) syncFinder(form, false);
    if (form && event.target.matches('[data-bff-find-date]')) event.target.setCustomValidity('');
    var area = event.target.closest('[data-bff-delivery-fields][data-bff-context="product"]');
    var plan = read();
    if (area && plan && event.target.matches('[data-bff-date], [data-bff-journey-zip]')) {
      var date = area.querySelector('[data-bff-date]'), zip = area.querySelector('[data-bff-journey-zip]');
      plan.date = date ? date.value : '';
      plan.zip = plan.mode === 'delivery' && zip ? core.zip(zip.value) : '';
      plan.savedAt = Date.now(); write(plan);
    }
  });
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-bff-mode-button]');
    var area = button && button.closest('[data-bff-context="product"]');
    var plan = area && read();
    if (!plan) return;
    setTimeout(function () {
      plan.mode = button.dataset.bffModeButton;
      var zip = area.querySelector('[data-bff-journey-zip]'), date = area.querySelector('[data-bff-date]');
      plan.zip = plan.mode === 'delivery' && zip ? core.zip(zip.value) : '';
      plan.date = date ? date.value : '';
      plan.savedAt = Date.now(); write(plan);
    }, 0);
  });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-bff-gift-finder]')) return;
    var mode = form.querySelector('[data-bff-find-mode]').value;
    var date = form.querySelector('[data-bff-find-date]');
    date.min = core.earliest(mode);
    date.setCustomValidity(date.value && core.sunday(date.value) ? form.dataset.unavailableDate : '');
    if (!form.reportValidity()) { event.preventDefault(); return; }
    var destination = new URL(form.querySelector('[data-bff-find-occasion]').value, window.location.origin);
    if (destination.origin !== window.location.origin || !/^\/collections\/[a-z0-9-]+\/?$/.test(destination.pathname)) { event.preventDefault(); return; }
    var zip = mode === 'delivery' ? core.zip(form.querySelector('[data-bff-find-zip]').value) : '';
    var plan = { mode: mode, zip: zip, date: date.value, occasion: destination.pathname, savedAt: Date.now() };
    write(plan);
    try {
      if (zip) sessionStorage.setItem('bff-delivery-address-v1', JSON.stringify({zip: zip, savedAt: Date.now()}));
      else sessionStorage.removeItem('bff-delivery-address-v1');
    } catch (error) {}
    form.action = destination.pathname;
    if (form.matches('[data-bff-catalog-destination]')) {
      event.preventDefault();
      form.dispatchEvent(new CustomEvent('bff:plan-saved', { bubbles: true, detail: plan }));
    }
  });
  document.addEventListener('invalid', function (event) {
    if (!event.target.closest('[data-bff-gift-finder]')) return;
    var details = event.target.closest('details');
    if (details) details.open = true;
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { ready(document); });
  else ready(document);
  document.addEventListener('shopify:section:load', function (event) { ready(event.target); });
})();
